import { render } from "./SectionGroup.vue?vue&type=template&id=1dff4f8b&scoped=true"
import script from "./SectionGroup.vue?vue&type=script&lang=js"
export * from "./SectionGroup.vue?vue&type=script&lang=js"

import "./SectionGroup.vue?vue&type=style&index=0&id=1dff4f8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dff4f8b"]])

export default __exports__